import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../../shared/icon/icon.component';
import { FlightRouteContent } from '../flight-route.model';

/** Link card for one flight route landing page (home page route grid, related routes). */
@Component({
  selector: 'app-route-card',
  imports: [RouterLink, DecimalPipe, IconComponent],
  templateUrl: './route-card.component.html',
  styleUrls: ['./route-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RouteCardComponent {
  readonly route = input.required<FlightRouteContent>();
}
